import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  TextField,
  Button,
  Alert,
  Paper,
  CircularProgress,
} from '@mui/material';
import { Link } from 'react-router-dom';
import apiService from '../../services/apiService';
import { API_ENDPOINTS } from '../../config/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // null | 'loading' | 'success' | 'error'
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setStatus('error');
      setErrorMessage('Kérjük, adja meg az email címét.');
      return;
    }

    setStatus('loading');
    try {
      await apiService.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
      setStatus('success');
    } catch (err) {
      setStatus('error');
      setErrorMessage('Hiba történt. Kérjük, próbálja újra később.');
    }
  };

  if (status === 'success') {
    return (
      <Container maxWidth="sm" sx={{ py: 6 }}>
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h5" gutterBottom>Email elküldve</Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Ha a megadott email cím regisztrált fiókhoz tartozik, hamarosan megérkezik a jelszó-visszaállítási link.
            Kérjük, ellenőrizze a leveleit (spam mappát is).
          </Typography>
          <Button component={Link} to="/login" variant="contained">
            Vissza a bejelentkezéshez
          </Button>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" align="center" gutterBottom>
          Elfelejtett jelszó
        </Typography>
        <Typography variant="body1" align="center" color="text.secondary" sx={{ mb: 4 }}>
          Adja meg a fiókjához tartozó email címét, és küldünk egy jelszó-visszaállítási linket.
        </Typography>

        {status === 'error' && (
          <Alert severity="error" sx={{ mb: 3 }} onClose={() => setStatus(null)}>
            {errorMessage}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Email cím"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={status === 'loading'}
            required
            sx={{ mb: 3 }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            disabled={status === 'loading'}
            sx={{ py: 1.5, mb: 2 }}
          >
            {status === 'loading' ? <CircularProgress size={24} color="inherit" /> : 'Link küldése'}
          </Button>
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <Button component={Link} to="/login" variant="text" size="small">
            Vissza a bejelentkezéshez
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default ForgotPassword;
